"use strict";
var TwilioSignatureGuard_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwilioSignatureGuard = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const crypto = tslib_1.__importStar(require("crypto"));
/**
 * Validates the X-Twilio-Signature header on incoming webhook callbacks.
 *
 * Twilio signs requests using HMAC-SHA1:
 *   signature = Base64( HMAC-SHA1( authToken, url + sorted_post_params ) )
 *
 * If TWILIO_AUTH_TOKEN is not set the guard passes through — allowing local
 * development without real Twilio credentials (stub mode).
 *
 * Docs: https://www.twilio.com/docs/usage/webhooks/webhooks-security
 */
let TwilioSignatureGuard = TwilioSignatureGuard_1 = class TwilioSignatureGuard {
    constructor() {
        this.logger = new common_1.Logger(TwilioSignatureGuard_1.name);
    }
    canActivate(context) {
        const authToken = process.env['TWILIO_AUTH_TOKEN'];
        if (!authToken) {
            this.logger.warn('TWILIO_AUTH_TOKEN not set — skipping signature verification (stub mode)');
            return true;
        }
        const req = context.switchToHttp().getRequest();
        const signature = req.headers['x-twilio-signature'];
        if (!signature) {
            this.logger.error('Missing X-Twilio-Signature header');
            throw new common_1.UnauthorizedException('Missing X-Twilio-Signature');
        }
        // Build the canonical URL Twilio signed (protocol + host + path, no query string)
        const protocol = req.headers['x-forwarded-proto'] ?? req.protocol;
        const host = req.headers['host'];
        const url = `${protocol}://${host}${req.originalUrl.split('?')[0]}`;
        // For POST with application/x-www-form-urlencoded, params are sorted POST body fields.
        // For JSON bodies (Twilio voice / status callbacks use form-encoded), body is already parsed.
        const params = req.body ?? {};
        const paramString = Object.keys(params)
            .sort()
            .reduce((acc, key) => acc + key + String(params[key]), '');
        const toSign = url + paramString;
        const hmac = crypto.createHmac('sha1', authToken);
        hmac.update(toSign, 'utf8');
        const computed = hmac.digest('base64');
        try {
            const sigBuf = Buffer.from(signature);
            const compBuf = Buffer.from(computed);
            // timingSafeEqual requires same-length buffers
            if (sigBuf.length !== compBuf.length) {
                throw new Error('length mismatch');
            }
            if (!crypto.timingSafeEqual(sigBuf, compBuf)) {
                throw new Error('mismatch');
            }
        }
        catch {
            this.logger.error(`Invalid Twilio signature from ${req.ip} — url: ${url}`);
            throw new common_1.UnauthorizedException('Invalid Twilio signature');
        }
        return true;
    }
};
exports.TwilioSignatureGuard = TwilioSignatureGuard;
exports.TwilioSignatureGuard = TwilioSignatureGuard = TwilioSignatureGuard_1 = tslib_1.__decorate([
    (0, common_1.Injectable)()
], TwilioSignatureGuard);
